import React from "react";
import type { Dayjs } from "dayjs";
import { DatePicker, Space, ConfigProvider } from "antd";
import dayjs from "dayjs";
import type { TimeRangePickerProps } from "antd";
import { DateFilterContainer, StyledChevronIcon } from "./styles";

const { RangePicker } = DatePicker;

interface DateFilterProps {
  value?: [Dayjs | null, Dayjs | null] | null;
  onChange?: (dates: [Dayjs | null, Dayjs | null] | null) => void;
  placeholder: [string, string];
  active?: boolean;
}

const rangePresets: TimeRangePickerProps["presets"] = [
  { label: "Last 7 Days", value: [dayjs().add(-7, "d"), dayjs()] },
  { label: "Last 14 Days", value: [dayjs().add(-14, "d"), dayjs()] },
  { label: "Last 30 Days", value: [dayjs().add(-30, "d"), dayjs()] },
  { label: "Last 90 Days", value: [dayjs().add(-90, "d"), dayjs()] },
];

const DateFilter: React.FC<DateFilterProps> = ({
  value,
  onChange,
  placeholder,
  active = false,
}) => {
  const handleRangeChange = (
    dates: null | (Dayjs | null)[],
    dateStrings: string[]
  ) => {
    if (onChange) {
      onChange(dates as [Dayjs | null, Dayjs | null] | null);
    }
  };

  return (
    <div style={{ cursor: "pointer" }}>
      <DateFilterContainer>
        <RangePicker
          presets={rangePresets}
          onChange={handleRangeChange}
          placeholder={placeholder}
          value={value}
          suffixIcon={
            <StyledChevronIcon
              style={{
                fill: active ? "#5B3FFF" : "#75849F",
              }}
            />
          }
          inputReadOnly={false}
          className="custom-date-filter"
          style={{
            outline: active ? "1px solid #5B3FFF" : "1px solid #E3E6F0",
            color: active ? "#5B3FFF" : "#42536A", // working
          }}
        />
      </DateFilterContainer>
    </div>
  );
};

export default DateFilter;
